<template>
    <div>
        <div class="ticket-sidebar-item">
            <div class="head">
                <p>Informații despre tichet</p>
            </div>
            <div class="body">
                <div class="body-item">
                    <p><strong>#{{ sidebarData.id }} - {{ sidebarData.subject }}</strong></p>
                    <p class="ticket-opened" :class="getClassByStatus(sidebarData.status)">{{ getNameByStatus(sidebarData.status) }}</p>
                </div>
                <div class="body-item">
                    <p><strong>Departament</strong></p>
                    <p>{{ sidebarData.department }}</p>
                </div>
                <div class="body-item">
                    <p><strong>A fost trimis</strong></p>
                    <p>{{ formatUtcDate(sidebarData.created, 'DD.MM.YYYY (HH:mm)') }}</p>
                </div>
                <div class="body-item">
                    <p><strong>Ultima actualizare</strong></p>
                    <p>{{ formatUtcDate(sidebarData.lastAction, 'DD.MM.YYYY (HH:mm)') }}</p>
                </div>
                <div class="body-item">
                    <div class="actions-buttons">
                        <div class="button-action green-button" @click="$emit('replyTicket')">Răspunde</div>
                        <div v-if="sidebarData.status !== 'closed'" class="button-action red-button" @click="$emit('closeTicket')">Închide</div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="ticket-sidebar-item">
            <div class="head">
                <p>Întrebări frecvente</p>
            </div>
            <div class="body">
                <div class="body-item">
                    <router-link to="/aplicatii/m3-sketch/tichete-suport">
                        <p>Întrebarea 1</p>
                    </router-link>
                </div>
                <div class="body-item">
                    <router-link to="/aplicatii/m3-sketch/tichete-suport">
                        <p>Întrebarea 2</p>
                    </router-link>
                </div>
                <div class="body-item">
                    <router-link to="/aplicatii/m3-sketch/tichete-suport">
                        <p>Întrebarea 3</p>
                    </router-link>
                </div>
                <div class="body-item">
                    <router-link to="/aplicatii/m3-sketch/tichete-suport">
                        <p>Întrebarea 4</p>
                    </router-link>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    import {BIconReplyFill, BIconXCircleFill} from 'bootstrap-vue';
    import {formatUtcDate} from '@/helpers/helpers'
    export default {
        components: {
            BIconReplyFill,
            BIconXCircleFill
        },
        props: {
            sidebarData: null
        },
        methods: {
            formatUtcDate,
            getNameByStatus(status) {
                if(status === 'opened') {
                    return 'Tichet deschis'
                } else if(status === 'client_replied') {
                    return 'Cu răspuns de la client'
                }else if(status === 'replied') {
                    return 'Tichet cu răspuns'
                }else if(status === 'closed') {
                    return 'Tichet închis'
                }
            },
            getClassByStatus(status) {
                if(status === 'opened') {
                    return 'opened-status'
                } else if(status === 'client_replied') {
                    return 'client-reply-status'
                }else if(status === 'replied') {
                    return 'agent-reply-status'
                }else if(status === 'closed') {
                    return 'closed-status'
                }
            }
        }
    }
</script>

<style scoped>
.ticket-sidebar-item{
    margin-bottom: 15px;
}
.ticket-sidebar-item .head{
    background: #6c757d;
    padding: 15px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.ticket-sidebar-item .head p{
    color: #fff;
}
.ticket-sidebar-item .body{
    border: 1px solid #6c757d;
}
.ticket-sidebar-item .body{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.body-item{
    padding: 10px 20px;
}
.body-item a{
    text-decoration: none;
}
.body-item:not(:last-child){
    border-bottom: 1px solid #545a6f;
}
.ticket-opened{
    color: #fff;
    padding: 3px;
    max-width: 160px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
}
.ticket-closed{
    background: #ea8196;
    color: #fff;
    padding: 3px;
    max-width: 120px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
}
.actions-buttons{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.button-action{
    width: 100%;
    max-width: 48%;
    color: #fff;
    font-size: 12px;
    padding: 5px 15px;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 4px;
    text-align: center;
}
.button-action:not(:last-child){
    margin-right: 10px;
}
.red-button{
    background: #ea8196;
}
.green-button{
    background: #49cda8;
}
.opened-status{
    background: #49cda8;
}
.client-reply-status{
    background: #8c6984;
}
.agent-reply-status{
    background: #ffc107;
}
.closed-status{
    background: #ea8196;
}
</style>
